module.exports = __webpack_public_path__ + "img/a1.ed0ca886.png";